import { showNotification } from "@mantine/notifications";
import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { customAxios } from "lib/axios";

export interface OrgRef {
  _id: string;
  name: string;
}

export interface DepartmentRef {
  _id: string;
  name: string;
}

export interface EmploymentHistoryItem {
  _id: string;
  startDate?: string;
  currency?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface Supervisor {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  position?: string;
  org: OrgRef;
  department?: DepartmentRef;
  completedWelcome?: boolean;
  isDemo?: boolean;
  status?: string;
  employmentType?: string;
  startDate?: string;
  isDeleted?: boolean;
  employmentHistory?: EmploymentHistoryItem[];
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export interface SupervisorsResponse {
  success: boolean;
  message?: string;
  count?: number;
  data: Supervisor[];
}

export const fetchOrganizationSupervisors = async (
  orgId: string
): Promise<Supervisor[]> => {
  const { data } = await customAxios.get<SupervisorsResponse>(
    `/users/organization/${orgId}/supervisors`
  );
  return data.data;
};

export const useOrganizationSupervisors = (orgId: string) =>
  useQuery<Supervisor[], AxiosError>(
    ["organizationSupervisors", orgId],
    () => fetchOrganizationSupervisors(orgId),
    {
      enabled: Boolean(orgId),
      onError: (error) =>
        showNotification({
          title: "Error Loading Supervisors",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load supervisors",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
    }
  );
